import { render, staticRenderFns } from "./chkResultRequest.vue?vue&type=template&id=828d7e7c&scoped=true&"
import script from "./chkResultRequest.vue?vue&type=script&lang=js&"
export * from "./chkResultRequest.vue?vue&type=script&lang=js&"
import style0 from "./chkResultRequest.vue?vue&type=style&index=0&id=828d7e7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828d7e7c",
  null
  
)

export default component.exports